import React from 'react';
import { useTranslation } from 'react-i18next';
import ContactCard from '../components/contact/ContactCard.jsx';
import { CONTACTS } from '../content/contacts.js';
import './ContactSection.css';

/**
 * «Ta kontakt» at the bottom of the groups page: a heading, one line, and one card per person
 * in CONTACTS. The section is `#kontakt`, where every "Ta kontakt" button leads.
 * @returns {JSX.Element} Contact section
 */
function ContactSection() {
  const { t } = useTranslation();

  return (
    <section className="contact-section" id="kontakt" aria-labelledby="kontakt-title">
      <div className="contact-section-content">
        <h2 id="kontakt-title">{t('contactSection.title')}</h2>
        <p className="contact-section-lead">{t('contactSection.lead')}</p>
        <div className="contact-section-grid">
          {CONTACTS.map((contact) => (
            <ContactCard key={contact.id} contact={contact} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
